import React, { useEffect, useState } from 'react';
import { LinkedinIcon, MailIcon, MessageCircleIcon, SendIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Footer() {
  const navigate = useNavigate();
  const [isHighlighted, setIsHighlighted] = useState(false);
  useEffect(() => {
    const handleHash = () => {
      if (window.location.hash === '#footer-contact') {
        setIsHighlighted(true);
        setTimeout(() => setIsHighlighted(false), 3000);
      }
    };
    handleHash();
    window.addEventListener('hashchange', handleHash);
    return () => window.removeEventListener('hashchange', handleHash);
  }, []);
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#0B1220] text-white py-12 px-6 relative overflow-hidden" data-id="element-126">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-127" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-128">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8" data-id="element-129">
          <div data-id="element-130">
            <div className="flex items-center gap-2 mb-4" data-id="element-131">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uagsrCkks4pAM6FSLjUDBW/image.png" alt="GS HRC Logo" className="w-10 h-10 rounded-lg" data-id="element-132" />
              <div className="flex flex-col items-start" data-id="element-133">
                <span className="text-xl font-bold leading-none" data-id="element-134">GS HRC</span>
                <span className="text-xs text-gray-400 leading-none" data-id="element-135">
                  Security Distribution
                </span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-136">
              Electronic security hardware distribution for verified businesses
              across EU, Middle East, and East Asia.
            </p>
          </div>
          <div data-id="element-137">
            <h4 className="font-semibold mb-4" data-id="element-138">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-139">
              <li data-id="element-140">
                <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors text-left" data-id="element-141">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-142">
                <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors text-left" data-id="element-143">
                  Terms of Service
                </button>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-white transition-colors" data-id="element-145">
                  Compliance Documentation
                </a>
              </li>
            </ul>
          </div>
          <div id="footer-contact" className="relative" data-id="element-146">
            <h4 className="font-semibold mb-4" data-id="element-147">Connect</h4>
            <div className={`flex flex-col gap-3 transition-all duration-300 ${isHighlighted ? 'animate-pulse' : ''}`} data-id="element-148">
              <div className={`absolute inset-0 rounded-xl transition-all duration-1000 ${isHighlighted ? 'bg-gradient-to-r from-[#3B82F6]/30 via-[#10B981]/30 to-[#3B82F6]/30 shadow-lg shadow-blue-500/50' : 'bg-transparent'}`} style={{
              animation: isHighlighted ? 'pulse 2s ease-in-out' : 'none'
            }} data-id="element-149" />
              <button onClick={scrollToContact} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group text-left relative z-10" data-id="element-150">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-151">
                  <MailIcon className="w-5 h-5" data-id="element-152" />
                </div>
                <span className="text-sm" data-id="element-153">contact@grapeskinhrc.com</span>
              </button>
              <a href="https://wa.me/message/A7TVXPCSWQCUH1?src=qr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group relative z-10" data-id="element-154">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-155">
                  <MessageCircleIcon className="w-5 h-5" data-id="element-156" />
                </div>
                <span className="text-sm" data-id="element-157">Text us on WhatsApp</span>
              </a>
              <a href="https://t.me/GrapeSkinhrc" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors group relative z-10" data-id="element-158">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-159">
                  <SendIcon className="w-5 h-5" data-id="element-160" />
                </div>
                <span className="text-sm" data-id="element-161">Message us on Telegram</span>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8" data-id="element-162">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-163">
            <p data-id="element-164">Operated by G.S. HRC. © 2017 All rights reserved.</p>
            <p className="text-center md:text-right" data-id="element-165">
              Products supplied to verified businesses only. No direct retail
              sales.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}